import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { toUtcDate } from '@rahtab/system/lib/tools/string';
import { InvoiceLineItem } from 'rahtab-redux/slices/invoicesSlice';

function useBilling() {
  const [refetch, { data, loading, called }] = useFetchCallType<DeptBillInfo>('GetDeptBillList');
  return {
    data: getBillingInfoReducer(data),
    loading,
    called,
    refetch,
  };
}

function getBillingInfoReducer(data?: DeptBillInfo): BillingInfo | undefined {
  if (!data) return;
  const billingInfo = data.DeptList.map((item) => {
    const {
      Amount: quantity,
      DeptCode: id,
      MeasureName: unitText,
      Price: total,
      Status: statusText,
      TemplateName: title,
    } = item;
    const merchandiseInfo = {
      id,
      quantity: parseFloat(quantity),
      unitText,
      title,
      total: parseFloat(total),
      statusText,
    };
    return merchandiseInfo;
  });
  return {
    items: billingInfo,
    currentDebt: data.TotalDept,
    debtLimit: data.MaxDept,
    debtExceeded: data.Overflow,
    debtExceededMessage: data.MaxDeptMessage,
    transactionCount: data.TransactionCount,
    from: toUtcDate(data.FromDate),
    to: toUtcDate(data.ToDate),
    total: parseFloat(data.TotalPrice),
  };
}
export default useBilling;

interface DeptBillInfo {
  TotalDept: string; //مجموع بدهی
  TotalPrice: string; //مجموع قیمت
  FromDate: string; // از تاریخ
  ToDate: string; // تا تاریخ
  MaxDept: string; // سقف مجاز بدهی
  MaxDeptMessage: string; // پیغام عبور از سقف بدهی
  Overflow: boolean; //فلگ عبور از سقف بدهی
  TransactionCount: string; //تعداد تراکنش‌ها
  DeptList: DeptInfo[]; //لیست بدهی ها
}
interface DeptInfo {
  DeptCode: string;
  TemplateName: string; // نام کالا
  Amount: string; //مقدار
  MeasureName: string; // واحد
  Price: string; //قیمت به ریال
  Status: string; // وضعیت
}
export interface BillingInfo {
  currentDebt: string;
  debtLimit: string;
  transactionCount: string;
  debtExceeded: boolean;
  debtExceededMessage: string;
  total: number;
  from: Date;
  to: Date;
  items: MerchandiseBillingInfo[];
}

export interface MerchandiseBillingInfo extends InvoiceLineItem {
  id: string;
  statusText: string;
}
